import React, { useCallback, FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { NavigationItemMenuModel } from './navigationItem/models/navigationItem.model';
import MenuLink from './menuLink/menuLink';
import NavigationItemMenuStructure from './navigationItemMenuStructure';
import { useMenuDispatcher } from '../menuContext';
import useScrollWithShadow from '../../../hooks/useScrollWithShadow';

export const NavigationItemTray: FC<{
  model: NavigationItemMenuModel;
  closeMainNavigation?: () => void;
  shouldShowScollShadow?: boolean;
}> = ({ model, closeMainNavigation, shouldShowScollShadow = false }) => {
  const { showShadowTop, showShadowBottom, scrollElementRef, onScrollHandler } = useScrollWithShadow();
  const menuDispatcher = useMenuDispatcher();
  // close menu element for navigation, both main navigation and accordion in mobile
  const handleLinkClick = useCallback(() => {
    menuDispatcher({ type: 'closeAll' });
    if (closeMainNavigation) closeMainNavigation(); // this is undefined in desktop
  }, [closeMainNavigation, menuDispatcher]);

  return (
    <>
      {shouldShowScollShadow && (
        <div
          className={`    
        pfe-navigation-item__tray-shadow
        ${showShadowTop ? ' pfe-navigation-item__tray-shadow--light-top' : ''}
        ${showShadowBottom ? ' pfe-navigation-item__tray-shadow--light-bottom' : ''}`}
        ></div>
      )}
      <div
        className={`pfe-navigation-item__tray pfe-navigation-item__tray--full-width${
          shouldShowScollShadow ? ' pfe-navigation-item__tray--scroll' : ''
        }`}
        onScroll={onScrollHandler}
        ref={scrollElementRef}
        style={{ position: 'relative', overflowY: 'auto' }}
      >
        {model.columns.map((columnModel, index) => {
          const isColumnGray = model.isLastColumnGray && index === 3;
          return (
            <div className={'pfe-navigation__custom-column' + (isColumnGray ? ' pfe-navigation__custom-column--gray' : '')} key={columnModel?.id}>
              {columnModel.elements.map((elementModel) => (
                <MenuLink model={elementModel} key={elementModel?.id} onClick={handleLinkClick} menuTitle={model?.displayName} />
              ))}
            </div>
          );
        })}
      </div>
    </>
  );
};

// Code flow of Primary links tray in Header(upto 1200px) -> NavigationItem -> NavigaionItemMenu
const NavigationItemMenu = ({ model }: { model: NavigationItemMenuModel }): JSX.Element => {
  return (
    <NavigationItemMenuStructure
      triggerContent={<RichText tag="span" field={model.menuTitle} className="navigation__menu-item__trigger__content rich-text" />}
    >
      <NavigationItemTray model={model} shouldShowScollShadow={true} />
    </NavigationItemMenuStructure>
  );
};

export default NavigationItemMenu;
